/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiProcessSetting.ts             *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-process-setting";

export class AutogenModelEdiProcessSetting<RowType extends ModelRow> extends Endpoint<RowType, RowEdiProcessSettingFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiProcessSetting extends ModelRow<RowEdiProcessSettingFields> {
	constructor(values?: Partial<RowEdiProcessSettingFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiProcessSettingFields {
	company_id: string;
	key_multi_threads: string;
	key_thread_q_multi: string;
	process: string;
	thread_q_max_size: number;
	threads_core_size: number;
	threads_max_size: number;
}

